module.exports = __webpack_public_path__ + "static/media/pentagram.1ad2d7e7.svg";